import React from 'react';
import HeroFullBackgroundImg from './HeroFullBackgroundImg';
import ImageContent from './ImageContent';
import StandardHero from './StandardHero';
import OppositeContentBlocks from './OppositeContentBlocks';
import StrainFinder from './StrainFinder';
import StrainFinderCarousel from './StrainFinderCarousel';
import ThreeImagesWithContent from './3ImagesWithContent';
import FAQ from './FAQ';
import ContentSlice from './ContentSlice';

export default function Slices(props) {
  if (!document) {
    return null;
  }

  return (
    <div className={`slice-wrapper`}>
      {props.slices.map((slice, index) => (
        <div
          key={index}
          className={`slice-single ${
            slice.primary.section_width === 'Half Width' ? 'desk_half_w' : 'desk_full_w'
          } ${slice.primary.background_color === 'black' ? 'black_back' : ''}`}>
          {slice.slice_type === 'hero_full_background_image' && HeroFullBackgroundImg(slice)}
          {slice.slice_type === 'image_content' && ImageContent(slice)}
          {slice.slice_type === 'standard_hero' && StandardHero(slice)}
          {slice.slice_type === 'opposite_content_blocks' && OppositeContentBlocks(slice)}
          {slice.slice_type === 'strain_finder' && StrainFinder(slice)}
          {slice.slice_type === 'strain_finder_carousel' && StrainFinderCarousel(slice)}
          {slice.slice_type === 'faq' && FAQ(slice)}
          {slice.slice_type === '3_images_with_content' && ThreeImagesWithContent(slice)}
          {slice.slice_type === 'content_slice' && ContentSlice(slice)}
        </div>
      ))}
    </div>
  );
}
